/**
 * Created on 2018-03-03.
 */

// node_modules

// modules

// properties
const VERSION = '1.0.0';
const NAME = 'mime-type-helper';

const TYPE = {
    IMAGE: ['image/jpeg', 'image/png', 'image/tiff', 'image/tiff-fx'],
    PDF: ['application/pdf', 'application/x-pdf', 'application/acrobat', 'applications/vnd.pdf', 'text/pdf', 'text/x-pdf'],
};

const FILE_TYPE = {
    IMAGE: 'image',
    PDF: 'pdf',
    DOCUMENT: 'document',
};

// methods

let fileTypeFromMimeType = (mimetype) => {
    for (let key in TYPE) {
        if (TYPE[key].indexOf(mimetype) !== -1) {
            return FILE_TYPE[key];
        }
    }

    return null;
};

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    TYPE: TYPE,
    FILE_TYPE: FILE_TYPE,
    fileTypeFromMimeType: fileTypeFromMimeType,
};